import React from "react";
import Histogram from "./Histogram";
import Bar from "./Bar";
import Pie from "./Pie";
import Map from "./Map";
import Table from "./Table";
import DataVisualizationType from "./DataVisualizationType";
import Section from "./Section";
import EmptyDataViz from "./EmptyDataViz";

const DataVisualization = ({data}) => {
    const {type} = data;

    if (type !== DataVisualizationType.SECTION && data.data.length === 0) {
        return <EmptyDataViz data={data}/>
    }

    switch (type) {
        case DataVisualizationType.HISTOGRAM:
            return <Histogram data={data}/>;
        case DataVisualizationType.BAR:
            return <Bar data={data}/>;
        case DataVisualizationType.PIE:
            return <Pie data={data}/>;
        case DataVisualizationType.MAP:
            return <Map data={data}/>;
        case DataVisualizationType.TABLE:
            return <Table data={data}/>;
        case DataVisualizationType.SECTION:
            return <Section data={data}/>;
        default:
            return null;
    }
};

export default DataVisualization;